// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__18tt-","container":"styles_container__3Ue6z","title":"styles_title__2zP-1","wrapper":"styles_wrapper__Q-aXX","answer":"styles_answer__2szAH"};